import { TeachersUIFilters } from '../../types/TeachersUIFilters';
import { safeParseEnum, safeParseEnumArray, safeParseNumber } from './safeParse';
import { TimeRange } from '../../types/TimeRange';
import { DayOfWeek } from '../../types/DayOfWeek';
import { Availability } from '../../types/Availability';
import { Modality } from '../../types/Modality';

export function parseFiltersFromSearchParams(searchParams: URLSearchParams): TeachersUIFilters {
  return {
    timeRanges: safeParseEnumArray(TimeRange, searchParams.get('timeRange')),
    daysOfWeek: safeParseEnumArray(DayOfWeek, searchParams.get('daysOfWeek')),
    availability: safeParseEnum(Availability, searchParams.get('availability')),
    modality: safeParseEnum(Modality, searchParams.get('modality')),
    minPricePerHour: safeParseNumber(searchParams.get('minPricePerHour')),
    maxPricePerHour: safeParseNumber(searchParams.get('maxPricePerHour'))
  };
}
